import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  token: Yup.string().required('Otp is required'),
});
